export const categoryOptions = [
  { value: "", text: "--Select Category--" },
  { value: "Electronics", text: "Electronics" },
  { value: "Toys", text: "Toys" },
  { value: "Automotive", text: "Automotive" },
  { value: "Pets", text: "Pets" },
  { value: "Health and Beauty", text: "Health and Beauty" },
  { value: "Clothing", text: "Clothing" },
  { value: "Jewelry", text: "Jewelry" },
  { value: "General Household", text: "General Household" },
  { value: "Other", text: "Other" },
];
